import React, {FC} from 'react';
import {connect} from 'react-redux';

import {ResolveStateProps} from '../../../../../libs/shared/core/src/store/helpers/commonReselectHelpers';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getHasUserTeamTrialExpired} from '../../../../store/data/teams/teamsSelectors';
import {TeamTrialEndedBanner} from './teamTrialEndedBanner';

/*
 * Props.
 */

type TrialEndedBannerContainerStateProps = ResolveStateProps<typeof mapStateToProps>;

/*
 * Component.
 */

export const TeamTrialEndedBannerContainerComponent: FC<TrialEndedBannerContainerStateProps> = (props) => {
  const {isUserTeamTrialExpired} = props;

  if (!isUserTeamTrialExpired) {
    return null;
  }

  return <TeamTrialEndedBanner />;
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isUserTeamTrialExpired: getHasUserTeamTrialExpired,
}));

export const TeamTrialEndedBannerContainer = connect(mapStateToProps)(TeamTrialEndedBannerContainerComponent);
